<ion-header class="shadow-none ion-no-margin bg-transparent">
  <ion-toolbar class="ion-no-padding">

    <!-- Page title -->
    <ion-text class="page-title ion-no-margin font-family-bold pb-0">
      {{ 'PRE_USE_LABEL19' | translate }}
    </ion-text>

    <!-- Add new vehicle action -->
    @if(!isMobileApp())
    {
    <ion-buttons slot="end" class="ion-no-padding">

      <ion-button class="btn_secondary" (click)="goToAddNewInspection()" (keydown.enter)="goToAddNewInspection()">
        <ion-text class="text-white ps-1 pe-1 pt-1 pb-1">{{'CONTINUE_BTN' | translate}}</ion-text>
      </ion-button>

      <ion-button [routerLink]="`/rectify-defects/${icnNo()}`" class="btn_secondary" routerDirection="forward"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <ion-text class="text-white ps-1 pe-1 pt-1 pb-1">{{'PRE_USE_LABEL12' | translate}}</ion-text>
      </ion-button>

      <ion-button class="btn_secondary_outline" [routerLink]="['/', 'pre-use-inspection']" routerDirection="forward"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <ion-text class="ps-1 pe-1 pt-1 pb-1">
          {{'ADD_NEW_PRE_USE_LABEL9' | translate}}
        </ion-text>
      </ion-button>

    </ion-buttons>
    }
  </ion-toolbar>

</ion-header>